import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UserState } from '../../../../shared/state/user/user.store';
import { UserQuery } from '../../../../shared/state/user/user.query';
import { filter, take } from 'rxjs/operators';
import { TreatmentService } from '../../../../shared/state/treatment/treatment.service';
import { getEntityType } from '@datorama/akita';
import { TreatmentState } from '../../../../shared/state/treatment/treatment.store';
import { TreatmentQuery } from '../../../../shared/state/treatment/treatment.query';
import { ModalController, NavController } from '@ionic/angular';
import { TreatmentWizardComponent } from '../../../treatment-wizard/pages/treatment-wizard/treatment-wizard.component';
import { CompanyService } from 'src/app/shared/state/company/company.service';
import { SettingsService } from 'src/app/shared/state/settings/settings.service';
import { HeaderPictureQuery } from '../../../../shared/state/header-picture/header-picture.query';
import { HeaderBackgroundQuery } from '../../../../shared/state/header-background/header-background.query';
import { HeaderIconQuery } from '../../../../shared/state/header-icon/header-icon.query';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { ClinicDetailQuery } from '../../../../shared/state/clinic-detail/clinic-detail.query';
import { ClinicQuery } from 'src/app/shared/state/clinic/clinic.query';

@Component({
    selector: 'app-treatment',
    templateUrl: './treatment.component.html',
    styleUrls: ['./treatment.component.scss'],
})
export class TreatmentComponent implements OnInit {
    user$: Observable<UserState>;
    treatments$: Observable<getEntityType<TreatmentState>[]>;
    companyOnlineShop$: Observable<boolean>;
    isLoadingContent;
    headerPicture$;
    headerBackground$;
    headerIcon$;
    appDelegate$: Observable<boolean>;

    /** Flowwwer template */
    clinicName$: Observable<string>;
    showBackButtonHeader$: Observable<boolean>;

    constructor(
        private userQuery: UserQuery,
        private treatmentService: TreatmentService,
        private treatmentQuery: TreatmentQuery,
        private modalController: ModalController,
        private settingsService: SettingsService,
        private headerPictureQuery: HeaderPictureQuery,
        private headerBackgroundQuery: HeaderBackgroundQuery,
        private headerIconQuery: HeaderIconQuery,
        private settingsQuery: SettingsQuery,
        private clinicDetailQuery: ClinicDetailQuery,
        private clinicQuery: ClinicQuery,
        private navCtrl: NavController
    ) {}

    ngOnInit(): void {
        this.headerPicture$ = this.headerPictureQuery.select('treatment');
        this.headerBackground$ = this.headerBackgroundQuery.select('treatment');
        this.headerIcon$ = this.headerIconQuery.select('treatment');
        this.user$ = this.userQuery.select();
        this.treatments$ = this.treatmentQuery.selectAll();
        this.companyOnlineShop$ = this.userQuery.select('onlineShop');
        this.appDelegate$ = this.clinicDetailQuery.select('appDelegate');
        /** Puede que aquí se llegue antes de tener el usuario, por eso me tengo que suscribir a Akita a esperarlo */
        this.userQuery
            .select()
            .pipe(
                filter((params) => params.tokenId !== ''),
                take(1)
            )
            .subscribe(async (_) => {
                await this.getTreatments();
            });

        /** Flowwwer template */
        this.clinicName$ = this.clinicDetailQuery.select('commercialName');
        this.showBackButtonHeader$ = this.settingsQuery.selectShowBackButtonHeader();
    }

    async refreshTreatments(event) {
        await this.getTreatments();
        event.target.complete();
    }

    async presentModalTreatmentWizard() {
        const modal = await this.modalController.create({
            component: TreatmentWizardComponent,
            cssClass: this.settingsQuery.browser
                ? 'modal-flowwwer modal-browser'
                : 'modal-flowwwer',
        });
        return await modal.present();
    }

    async getTreatments() {
        this.isLoadingContent = true;
        try {
            await this.treatmentService.getTreatments();
        } catch (error) {
            this.isLoadingContent = false;
        }
        this.isLoadingContent = false;
    }

    /** Flowwwer template */
    //TODO: Mirar si sacar a un servicio ya que se usa en mucho sitios
    goHome(event) {
        event?.stopPropagation();
        /** Solo puedo volver atrás si no estoy en personalzas o si soy personalizada y tengo más de 1 centro */
        if (
            !this.settingsQuery.isPersonalized() ||
            this.clinicQuery.getValue().clinicsFound.length > 1
        ) {
            this.navCtrl.navigateBack(
                '/' +
                    (this.settingsQuery.isPersonalized()
                        ? this.settingsQuery.currentSystemKey
                        : '')
            );
        }
    }
}
